<div #meetIFrame class="full-screen mask"></div>
